import api from "@/modules/global/lib/api-client.js";
import { update } from "lodash";

export default {
  namespaced: true,
  state: {
    projectStructure: {
      project: null,
      projectName: null,
      schools: null
    },
    schoolId: null,
    wonderSchoolName: null,
    userProfile: {
      lockJourney: null,
      addEnglish: null
    }
  },
  getters: {
    getProjectStructure: state => {
      return state.projectStructure;
    },
    getWondeSchools: state => {
      return state.wondeSchools;
    }
  },
  mutations: {
    setCurrentProjectStructure(state, resp) {
      state.projectStructure = resp;
    },
    setUserProfile(state, userSettings) {
      state.userProfile = userSettings;
    }
  },
  actions: {
    async updateLearnerPassword({ commit }, userPayload) {
      let request = await api.put("users/update-learner-password", {
        json: {
          userPayload
        }
      });

      if (request && request.status === 200) {
        return true;
      } else {
        return false;
      }
    },
    async fetchProjectStructure({ commit }, projectId) {
      let request = await api.get(`project/structure/${projectId}`);
      if (request.ok) {
        let response = await request.json();
        commit("setCurrentProjectStructure", response);
        return true;
      } else {
        return false;
      }
    },
    async updateWondeSchoolId({ commit }, id) {
      commit("setSchoolId", id);
    },
    async updateWondeName({ commit }, name) {
      commit("setSchoolName", name);
    },
    async addEnglishAndLockJourney({ commit }, options) {
      commit("setUserProfile", options);
    },
    async fetchWondeSchool({ commit }) {
      let request = await api.get("wonde/get-schools");
      if (request.ok) {
        let schools = await request.json();
        const listOfSchools = schools.schools.data.map(school => ({
          id: school.id,
          name: school.name
        }));
        return listOfSchools;
      } else {
        return false;
      }
    },
    async fetchStudents({ commit, state }, school) {
      let endpoint = `wonde/get-school-students/${school.id}?include=contact_details,year,education_details&per_page=${school.pageLimit}&page=${school.pageNumber}`;
      let request = await api.get(endpoint);
      if (request.ok) {
        let learners = await request.json();
        const listOfLearners = learners.students.map(learner => ({
          email: learner.contact_details.data.emails.email
            ? learner.contact_details.data.emails.email
            : learner.id.toLowerCase() + "@reflectivelearning.co.za",
          phone: learner.contact_details.data.phones.mobile
            ? learner.contact_details.data.phones.mobile
            : null, //mobile|work|home|primary|phone
          firstName: learner.forename,
          lastName: learner.surname,
          preferredName: learner.forename,
          grade:
            learner.year && learner.year.data.code ? learner.year.data.code : 0,
          gender: learner.gender,
          studentNumber: learner.id,
          password: learner.forename
            .slice(0, 3)
            .concat("123")
            .toLowerCase(),
          project: school.project,
          school: school.name,
          subject: school.subjects,
          lockedJourneys: school.lockJourney,
          language: school.language,
          sendRegEmail: learner.contact_details.data.emails.email ? true : false
        }));
        return {
          students: listOfLearners,
          pagination: learners.pagination
        };
      } else {
        return false;
      }
    },
    async submitProjectStructure({ commit }, project) {
      let request = await api.put(`project`, {
        json: {
          project
        }
      });
      if (request.ok) {
        return {
          submitted: true,
          message: "Project successfully submitted!"
        };
      } else {
        let text = await request.text();
        return {
          submitted: false,
          message: "Submission failed, reason: \n" + text
        };
      }
    },
    async addProjectStructure({ commit }, projects) {
      let request = await api.put(`project/add`, {
        json: {
          project: projects
        }
      });
      if (request.ok) {
        return {
          submitted: true,
          message: "Project successfully submitted!"
        };
      } else {
        let text = await request.text();
        return {
          submitted: false,
          message: "Submission failed, reason: \n" + text
        };
      }
    },
    async updateProjectStructure({ commit }, projects) {
      let request = await api.put(`project/update`, {
        json: {
          project: projects
        }
      });
      if (request.ok) {
        return {
          submitted: true,
          message: "Project successfully updated!"
        };
      } else {
        let text = await request.text();
        return {
          submitted: false,
          message: "Submission failed, reason: \n" + text
        };
      }
    },
    async submitProjectAdmin({ commit }, projectAdmin) {
      let request = await api.put("generate-admin", {
        json: {
          projectAdmin
        }
      });
      if (request.ok) {
        return {
          submitted: true,
          message: "Project admin successfully submitted!"
        };
      } else {
        let reason = await request.text();
        return {
          submitted: false,
          message: "Submission failed, reason: \n" + reason
        };
      }
    },
    async addLearnerToProject({ commit }, learner) {
      const addLearner = await api.post(`addLearner`, {
        json: {
          learner
        }
      });

      if (addLearner.ok) {
        return {
          submitted: true,
          message: "Learner was added successfully."
        };
      } else {
        return {
          submitted: false,
          message: addLearner.statusText
        };
      }
    },
    async deleteProjectAdmin({ commit }, adminsEmails) {
      const removeAdmins = await api.delete(`delete-project-admins`, {
        json: {
          emails: adminsEmails
        }
      });

      if (removeAdmins.ok) {
        return {
          submitted: true,
          message: "Admins were succssfully removed!!."
        };
      } else {
        return {
          submitted: false,
          message: "User not found, please verify email."
        };
      }
    },
    async submitLearners({ commit }, form) {
      let request = await api.put("bulk-process/upload-learners", {
        json: {
          form
        },
        timeout: 147483647
      });
      let response = await request.text();
      if (request.ok) {
        return {
          submitted: true,
          message: response
        };
      } else {
        return {
          submitted: false,
          message: "Submission failed, reason: " + response
        };
      }
    },
    async updateClasses({ commit }, learners) {
      let request = await api.put("bulk-process/update-classes", {
        json: {
          learners
        }
      });

      let response = await request.text();
      if (request.ok) {
        return {
          submitted: true,
          message: "Classes were successfully updated."
        };
      } else {
        return {
          submitted: false,
          message: "Submission failed, reason: " + response
        };
      }
    },
    async fetchEngagements({ commit }, schoolName) {
      let request = await api.get(`engagement/learners/?school=${schoolName}`);
      if (request.ok) {
        let response = await request.json();
        return {
          name: schoolName,
          data: response
        };
      } else {
        return {
          success: false,
          message: "Could not get engagements."
        };
      }
    },
    async fetchLearners({ commit, state }, school) {
      let request = await api.get(`dashboard?school=${school}`);
      if (request.ok) {
        let response = await request.json();
        return response;
      } else {
        return {
          success: false,
          message: "Could not get learners."
        };
      }
    },
    async processReports({ commit, state }, params) {
      let request = await api.post(`pdf-reports`, {
        json: params
      });
      if (request && request.status === 200) {
        let response = await request.json();
        return response;
      } else {
        return false;
      }
    }
  }
};
